import React, { useState, useEffect } from 'react';
import { Image as KonvaImage } from 'react-konva';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_MONITOR_STORE } from 'store';
import { EntityImageProps } from './types';

const EntityImage = (props: EntityImageProps) => {
  const {
    interactiveAreaId,
    x,
    y,
    [EDITOR_MONITOR_STORE]: {
      getEntityImageByIAId,
      getColorByIAId,
      showIaPictures
    },
    img = getEntityImageByIAId(interactiveAreaId),
    color = getColorByIAId(interactiveAreaId)
  } = props;

  const [image, setImage] = useState(null);

  useEffect(() => {
    if (!img) return;
    const imageDom = new Image(50, 65);
    imageDom.src = img.src;
    const handleLoad = () => {
      setImage(imageDom);
    };
    imageDom.addEventListener('load', handleLoad);

    return () => imageDom.removeEventListener('load', handleLoad);
  }, [img]);

  return (showIaPictures && img)
    ? (
      <KonvaImage
        x={x - 55}
        y={y}
        image={image}
        stroke={color}
        strokeWidth={3}
      />
    )
    : null;
};

export default inject(EDITOR_MONITOR_STORE)(observer(EntityImage));
